import { SettingsRoutes } from 'pages/settings/route/type'
import { BillingRoutes } from './type'

const root = `${SettingsRoutes.root}/${BillingRoutes.root}`
const overview = `${root}/${BillingRoutes.overview}`
const upgrade = `${overview}/${BillingRoutes.upgrade}`

export const BillingPath = {
  root: root,
  overview: overview,
  upgrade: upgrade,
}
